import BaseAnnotationLayer from "./BaseAnnotationLayer";

class RBCLayer extends BaseAnnotationLayer {
    id = "RBCLayer";
    label = "RBC Layer"
    drawer = 7;
    tools = [];

    // onFeatureSelect = (feature) => {
    //     markAnnotation(this.props.map.get('id'), feature.getProperties().annotation);
    //     store.dispatch(reset());
    //     store.dispatch(bloodAnnoSelected(feature.getProperties().annotation));
    //     const bloodGridRBCData = store.getState().bloodGridRBCReducer
    //     const bloodGridData = store.getState().bloodGridReducer
    //     const activeMapId = store.getState().gammaStateReducer.activeMapId;
    //     const slide_id = store.getState().mapsStateReducer[activeMapId]?.slideId;
    //
    //     if (notNull(slide_id)) {
    //         const pageSize = bloodGridData.page_size;
    //         console.log("__", pageSize)
    //         const anno_id = feature.getProperties().annotation.id;
    //         const url = `/api/get_selected_anno_page/?anno_id=${anno_id}&slide_id=${slide_id}&tag=${bloodGridData.tag}&page_size=${pageSize}`;
    //         get(url).then(res => {
    //             console.log("__page", res['page']);
    //             store.dispatch(updatePage(res["page"]))
    //         });
    //     }
    // }
}

export default RBCLayer;